import { useEffect, useState } from "react"
import { changeDateLastTwoMonthsChart, getStepsStatsAverageInDay } from "redux/reducers/stepsReducer"
import moment from "moment";
import { lastYearsPerMonth } from "resources/ParametersTypes"
import BarChartDateArrowSelector from "components/Charts/BarChartDateArrowSelector";
import { Dashboard } from "locale/es";
import { useDispatch, useSelector } from "react-redux";

const PerWeekAvgInMonth = () => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString())
  const patientId = useSelector(({ patient }) => patient.id)
  const { data, status } = useSelector(({ stepsData }) => stepsData.lastTwoMonthsPatientData)
  const chartData = useSelector(({ stepsData }) => stepsData.perWeekChartAvgStepsInMonth)
  const dispatch = useDispatch()


  useEffect(() => {
    if (patientId && selectedDate) {
      dispatch(getStepsStatsAverageInDay(patientId, selectedDate));
    }
  }, [patientId, selectedDate, dispatch]);

  useEffect(() => {
    if (patientId && !!selectedDate && !!status) {
      dispatch(changeDateLastTwoMonthsChart(selectedDate))
    }
  }, [data, dispatch, patientId, selectedDate, status])

  return (
    <BarChartDateArrowSelector
      dataToShow={chartData}
      title={Dashboard.AVERAGE_STEPS_DAY}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      minDate={lastYearsPerMonth}
      maxDate={moment()}
      interval={'month'}
    />
  )

}

export default PerWeekAvgInMonth

